'use client';
import { Button, Flex, Text, Title } from '@gjensidige/builders-components';
import YouTubePlayer from './components/youtube-player';
import QbrickPlayer from './components/qbrick-player';

import type { VideoProps as Props } from './types';

import styles from './video.module.css';

export const Video = ({
  button,
  qbrickMediaId,
  reverseOrder,
  text,
  title,
  youtubeVideoLink: youtube
}: Props) => (
  <Flex
    align="end"
    center
    className={styles.marginYParts}
    direction={reverseOrder ? 'row-reverse' : 'row'}
    gap={{ xs: 'sm md', md: 'sm xl' }}
    justify={reverseOrder ? 'start' : 'end'}
    layout={{ xs: 1, md: 2 }}
  >
    {!!title && !text && !button && <div /> /* Push content if only title */}
    {!!(title || text || button) && (
      <Flex layout="1" gap={{ xs: 'sm', md: 'sm' }}>
        {!!title && <Title size="4" text={title} />}
        {!!text && (
          <Text
            as="div"
            className={styles.htmlArea}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        {!!button && (
          <div>
            <Button
              href={button.url}
              target={button.newWindow ? '_blank' : undefined}
            >
              {button.text}
            </Button>
          </div>
        )}
      </Flex>
    )}
    {qbrickMediaId ? (
      <QbrickPlayer videoId={qbrickMediaId} />
    ) : (
      youtube && <YouTubePlayer videoId={youtube} title={title} />
    )}
  </Flex>
);
